import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {SpacierArcadeStickySymbol} from "../../symbols/SpacierArcadeStickySymbol";
import {SpacierArcadeGameConfig} from "../../SpacierArcadeGameConfig";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineLite} from "gsap";
import {ISymbolStateConfig} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {SASymbols, SpacierArcadeReelSymbol} from "../../symbols/SpacierArcadeReelSymbol";
import {SpacierArcadeWildSymbol} from "../../symbols/SpacierArcadeWildSymbol";
import {SpacierArcadeModeData} from "../../server/data/SpacierArcadeModeData";
import {SAHelper} from "../../utils/SAHelper";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SpacierArcadeSoundConfig} from "../../SpacierArcadeSoundConfig";

export class SpacierArcadeOverlayView extends BaseView{
    private _layer:ScalableLayer;
    private _allOverlaySymbols:SpacierArcadeStickySymbol[];
    private _playemitter:boolean = false;

    constructor() {
        super();
        this._allOverlaySymbols = [];
        this._layer = StageManager.getLayer(SpacierArcadeGameConfig.instance.LAYERS.SYMBOLS_ATTENTION.name);
    }

    public animateOverlays(overlaySymbols:string[][], existingOverlaySyms:string[], reelId:number, isFirst:boolean):TimelineLite {
        let stickyTimeLine:TimelineLite = new TimelineLite();
        stickyTimeLine.add(() => {
            const loopCount: number = reelId + 1;
            let loopInitial: number = (isFirst) ? 0 : reelId;

            for (let i: number = loopInitial; i < loopCount; i++) {
                let index: number = i;
                for (let j: number = 0; j < overlaySymbols[index].length; j++) {
                    if (overlaySymbols[index][j] !== null) {
                        let oldsymbol: any = Reels.getSymbol(index, j);
                        stickyTimeLine.add(oldsymbol.changeState({state: SpacierArcadeGameConfig.instance.SYMBOL_STATES.stickyPump}));
                    }
                }
            }
        });
        return stickyTimeLine;
    }

    private animateSymbolDependingOnState(overlaySymbols:string[][], index:number, symIndex:number, isFirst:boolean):void{
        if(overlaySymbols[index][symIndex] !== null) {
            let oldsymbol: any = Reels.getSymbol(index, symIndex);
            oldsymbol.changeState({state: SpacierArcadeGameConfig.instance.SYMBOL_STATES.stickyPump});
        }
    }


    private hasNewOverlays(newOverlaySymbols:string[][], existingOverlaySyms:string[], reelId:number):boolean{
        let returnValue:boolean = false;
        if(newOverlaySymbols.length > 0){
            newOverlaySymbols[reelId].forEach((subItem) => {
                    if(subItem !== null && existingOverlaySyms.indexOf(subItem) >= 0){
                        returnValue = true;
                        return;
                    }
                });
        }
        return returnValue;
    }




    public getNewStickySymbols(overlaySymbols:string[][], overlayWidsMultiplier:number[][], spinIntensity:number, isRestore?:boolean):TimelineLite {
        let stickyTimeLine:TimelineLite = new TimelineLite();
        stickyTimeLine.add(() => {
            SlotGame.sound.playEffect(SpacierArcadeSoundConfig.instance.FS_SYMBOL_LOCKING);
            this.getExistingSymbolsStickyIntensity(spinIntensity);
        })
        for(let i:number = 0; i < overlaySymbols.length; i++) {
            stickyTimeLine.add(this.addStickyAnimation(overlaySymbols[i], overlayWidsMultiplier[i], i, spinIntensity, isRestore), 0.05);
        }
        return stickyTimeLine;
    }

    private getExistingSymbolsStickyIntensity(spinIntensity:number):void{
        this._allOverlaySymbols.forEach((item) => {
            if(item && item.stickySymbol){
                item.stickySymbol.symbolSpinIntensity = spinIntensity;
                item.stickySymbol.changeState({state: SpacierArcadeGameConfig.instance.SYMBOL_STATES.stickyIntensity})
            }
        })
    }

    //TODO
    private addStickyAnimation(overlaySymbols:string[], overlayWidsMultiplier:number[], reelId:number, spinIntensity:number, isRestore?:boolean):TimelineLite{
        let stickyTimeLine:TimelineLite = new TimelineLite();
        for(let i:number = 0; i < overlaySymbols.length; i++) {
            if(overlaySymbols[i] !== null && (SpacierArcadeModeData.instance.isMainGame || overlaySymbols[i] !== SASymbols.W || isRestore)) {
                let stickySymbol:SpacierArcadeStickySymbol = this.getStickySymbol(reelId, i, overlayWidsMultiplier[i], overlaySymbols[i], spinIntensity);
                stickySymbol.alpha = 0;

                let oldsymbol: any = Reels.getSymbol(reelId, i);
                stickyTimeLine.add([
                    () => {
                        stickySymbol.alpha = 1;
                        oldsymbol.parent && oldsymbol.changeState({state: SpacierArcadeGameConfig.instance.SYMBOL_STATES.normal});
                    },
                    stickySymbol.stickySymbol.changeState({state: SpacierArcadeGameConfig.instance.SYMBOL_STATES.stickyPump})
                ], 0);
            }
        }
        return stickyTimeLine;
    }

    public getStickySymbol(reel:number, position:number, multiplier:number, symName:string, spinIntensity?:number, symState?: ISymbolStateConfig):SpacierArcadeStickySymbol {
        let stickySymbol:SpacierArcadeStickySymbol = new SpacierArcadeStickySymbol(symName, new PIXI.Point(reel, position), multiplier, spinIntensity, symState);
        let helperPos = SAHelper.getSymbolPositions(reel, position);
        let posY:number = SpacierArcadeModeData.instance.isFreespin? helperPos[1] : helperPos[1];
        stickySymbol.position.x = helperPos[0] - SpacierArcadeGameConfig.instance.REEL_AREA_POS_X;
        stickySymbol.position.y = posY - SpacierArcadeGameConfig.instance.REEL_AREA_POS_Y;
        let parentContainer:PIXI.Container = <PIXI.Container>(this._layer.children.length > 0 ? this._layer.children[0] : this._layer);
        parentContainer.addChildAt(stickySymbol, 0);
        this._allOverlaySymbols.push(stickySymbol);
        return stickySymbol;
    }

    public updateWildOverlayMultiplier(overlayWidsMultiplier:number[][]):TimelineLite{
        const stateTl:TimelineLite = new TimelineLite();
        for(let i:number = 0; i < overlayWidsMultiplier.length; i++) {
            for(let j:number = 0; j < overlayWidsMultiplier[i].length; j++) {
                if (overlayWidsMultiplier[i][j] > 0) {
                    let overlaySymbol: SpacierArcadeStickySymbol[] = this._allOverlaySymbols.filter((item) => {
                        return item.originalReelPosition.x === i && item.originalReelPosition.y === j
                    });
                    if (overlaySymbol.length > 0) {
                        let stateSymbol: SpacierArcadeWildSymbol = <SpacierArcadeWildSymbol>overlaySymbol[0].children[0];
                        if(stateSymbol.multiplier === 0 || stateSymbol.multiplier !== overlayWidsMultiplier[i][j]) {
                            stateSymbol.multiplier = overlayWidsMultiplier[i][j];
                            stateTl.add(stateSymbol.changeState({
                                state: SpacierArcadeGameConfig.instance.SYMBOL_STATES.multiplier
                            }), 0);
                        }
                    }
                }
            }
        }
        return stateTl;
    }

    public abortDisableOverlayWilds(overlayMultipliers:number[][]):TimelineLite {
        const stateTl:TimelineLite = new TimelineLite();
        let stickyOverlay:SpacierArcadeStickySymbol;
        while(this._allOverlaySymbols.length > 0) {
            stickyOverlay = this._allOverlaySymbols.pop()!;
            let oldsymbol:SpacierArcadeReelSymbol = <SpacierArcadeReelSymbol>Reels.getSymbol(stickyOverlay.originalReelPosition.x, stickyOverlay.originalReelPosition.y);
            let newSymbol = oldsymbol.replaceWithNewSymbolInReel(stickyOverlay.originalSymbolName, true);
            newSymbol.multiplier = overlayMultipliers[stickyOverlay.originalReelPosition.x][stickyOverlay.originalReelPosition.y];
            newSymbol.changeState({
                state: SpacierArcadeGameConfig.instance.SYMBOL_STATES.normal
            });
            let parentContainer:PIXI.Container = <PIXI.Container>(this._layer.children.length > 0 ? this._layer.children[0] : this._layer);
            parentContainer.removeChild(stickyOverlay);
        }
        return stateTl;
    }
}